<p-panel header="{{ ('fs.res.patent.Patent.inventors.percentages'|hisUi) + getPersonName() }}">

    <div class="infoMessage">
        <span>{{'fs.res.patent.inventors.autoPercentage.infoMessage'|hisUi}}</span>
    </div>
    <br/>

    <his-plam>
        <input #content hisDdKey="fs.res.patent.PatentInventor.percentage" class="inputWidth100" type="number"
            [(ngModel)]="patentInventor.percentage" />
    </his-plam>

</p-panel>